import React, { useEffect, useState } from "react";
import ManagerRoomMonthView from './ManagerRoomMonthView';
import MakeRoomFooterButton from './MakeRoomFooterButton';

import ModalNotify from '../../../../features/ModalNotify';
import { useDispatch, useSelector } from "react-redux";
import { checkRoomSaleRoomOnWebsite } from '../../../../api/booking';
import { saveSaleRoomOnWebsite } from '../../../../api/saleRoom';

import { errorToast, informationToast, } from '../../../../utils/Toast/index'; //warningToast, 
import { modalAction, unitsAction } from '../../../../redux/actions';

function SaleRomOnWebsite() {
    const auth = useSelector(state => state.auth);
    const token = useSelector(state => state.token);
    const { branchID } = auth.user;
    const dispatch = useDispatch();
    
    const [guestNumberData, setGuestNumberData] = useState({
        content: [],
        roomTotal: 0,
        isLoading: true,
        saleRoom: {
        time1: {
            after: 0,
            salePercent: 0
        },
        time2: {
            after: 0,
            salePercent: 0
        }
        },
        overrides: {}
    });

    const [listRoom, setListRoom] = useState([]);
    const [percentSale, setPercentSale] = useState({});
    const [listAutoUpdate, setListAutoUpdate] = useState(Array(31).fill(false));
    const [saleOverrides, setSaleOverrides] = useState({});
    const now = new Date();
    const [currentMonth, setCurrentMonth] = useState(now.getMonth());
    const [currentYear, setCurrentYear] = useState(now.getFullYear());
    const [loading, setLoading] = useState(false);
    const [overrides, setOverriders] = useState({});

    function updateSaleRoom(autoDaysSet, monthStr, saleOverrides, listAutoUpdate) {
        const updateRSaelRoomOnServer = async () => {

            // check index have true in listAutoUpdate

            // console.log("listAutoUpdate", listAutoUpdate);
            // console.log("listRoom", listRoom);

            const payload = { 
                month: monthStr, 
                listAutoUpdate,
                listRoom,
                saleOverrides,
            };
            const dataResult = await saveSaleRoomOnWebsite(branchID, payload, token);

            console.log("dataResult", dataResult.data)
            informationToast && informationToast('Saved overrides');
        }

        updateRSaelRoomOnServer()
    }

    function onChangeSaleRoom(value, typeKey, day, maxNumber) {
        // console.log("listRoom",  listRoom)
        // console.log("value", value, "typeKey", typeKey, "day", day, "maxNumber", maxNumber)
        
        const newListRoom = { ...listRoom };    
        newListRoom[typeKey]["sale"][day] = value <= maxNumber ? Number(value) : maxNumber;

        setListRoom(newListRoom);
    }

    const loadDataForMonth = async (year, month) => {
        try {
            setLoading(true);
            dispatch(unitsAction.showLoading());
            const dataLoad = await checkRoomSaleRoomOnWebsite(branchID, token);
            console.log("dataLoad", dataLoad.data);
            if (dataLoad) {
                const apiRooms = dataLoad.data && dataLoad.data.listRoom ? dataLoad.data.listRoom : {};
                const percentSale = dataLoad.data && dataLoad.data.percentSale ? dataLoad.data.percentSale : {};

                setListRoom(apiRooms);
                setPercentSale(percentSale);
                if (dataLoad.data.listAutoUpdate) {
                    setListAutoUpdate(dataLoad.data.listAutoUpdate);
                } else {
                    setListAutoUpdate(Array(31).fill(false));
                }
                setGuestNumberData(prev => ({
                    ...prev,
                    content: Array.isArray(apiRooms) ? apiRooms : [],
                    roomTotal: dataLoad.data.room || 0,
                    isLoading: false
                }));

               
            }
        } catch (err) {
            setGuestNumberData(prev => ({ ...prev, isLoading: false }));
            errorToast && errorToast("Failed to load room data");
        } finally {
            setLoading(false);
            dispatch(unitsAction.hiddenLoading());
        }
    }

    const onPrevMonth = async () => {
        const newMonth = currentMonth === 0 ? 11 : currentMonth - 1;
        const newYear = currentMonth === 0 ? currentYear - 1 : currentYear;
        await loadDataForMonth(newYear, newMonth);
        setCurrentMonth(newMonth);
        setCurrentYear(newYear);
    };

    const onNextMonth = async () => {
        const newMonth = currentMonth === 11 ? 0 : currentMonth + 1;
        const newYear = currentMonth === 11 ? currentYear + 1 : currentYear;
        await loadDataForMonth(newYear, newMonth);
        setCurrentMonth(newMonth);
        setCurrentYear(newYear);
    };
    
    useEffect(() => {
        const loadData = async () => {
            try {
                dispatch(unitsAction.showLoading());
                const dataLoad = await checkRoomSaleRoomOnWebsite(branchID, String(currentMonth + 1).padStart(2, '0'), currentYear, token);
                if (dataLoad) {
                    
                    const apiRooms = dataLoad.data && dataLoad.data.listRoom ? dataLoad.data.listRoom : {};
                    const percentSale = dataLoad.data && dataLoad.data.percentSale ? dataLoad.data.percentSale : {};

                    setPercentSale(percentSale);
                    setListRoom(apiRooms);
                    if (dataLoad.data.listAutoUpdate) {
                        setListAutoUpdate(dataLoad.data.listAutoUpdate);
                    } else {
                        setListAutoUpdate(Array(31).fill(false));
                    }
                    setGuestNumberData(prev => ({
                        ...prev,
                        
                        content: Array.isArray(apiRooms) ? apiRooms : [],
                        roomTotal: dataLoad.data.room || 0,
                        isLoading: false,
                        saleRoom: dataLoad.data.saleRoom || {}
                    }));

                    setOverriders(dataLoad.data.overrides);
                    
                }
                dispatch(unitsAction.hiddenLoading());
            } catch (err) {
                setGuestNumberData(prev => ({ ...prev, isLoading: false }));
                errorToast && errorToast("Failed to load room data");
                dispatch(unitsAction.hiddenLoading());
            }
        }

        if (branchID) loadData();

    }, [branchID, token, currentMonth, currentYear, dispatch])

    function closeModal() { dispatch(modalAction.modalReset()); }

    return (
        <React.Fragment>
            <ModalNotify closeModal={closeModal} />
            <div style={{fontSize:"4rem", fontWeight: "600"}}>Sale Room On Website Azumaya</div>
            <div className="d-flex justify-content-center" >
                <h3 style={{border:"1px solid", marginBottom: "0px", padding: "5px"}}>Sale Room Information </h3>
                <div style={{border:"1px solid", padding: "5px"}}>
                    <h3 >Normal: Sale 50%</h3>
                    <h3>Time 1: Before {guestNumberData.saleRoom.time1?.after || 0} days - Sale : {guestNumberData.saleRoom.time1?.salePercent +"%" || 0}</h3>
                    <h3>Time 2: Before {guestNumberData.saleRoom.time2?.after || 0} days - Sale : {guestNumberData.saleRoom.time2?.salePercent +"%" || 0}</h3>
                </div>

            </div>

            {/* Manager Room UI (Month View) */}
            <ManagerRoomMonthView 
                listRoom={listRoom}
                percentSale={percentSale}
                branchID={branchID}
                token={token}
                updateSaleRoom={updateSaleRoom}
                currentMonth={currentMonth}
                currentYear={currentYear}
                onPrevMonth={onPrevMonth}
                onNextMonth={onNextMonth}
                loading={loading}
                listAutoUpdate={listAutoUpdate}
                overrides={overrides}
                setListAutoUpdate={setListAutoUpdate}
                saleOverrides={saleOverrides}
                setSaleOverrides={setSaleOverrides}
                onChangeSaleRoom={onChangeSaleRoom}
            />
            <MakeRoomFooterButton
                currentYear={currentYear}
                currentMonth={currentMonth}
                saleOverrides={saleOverrides}
                listAutoUpdate={listAutoUpdate}
                updateSaleRoom={updateSaleRoom}
            />
            {/* <ul className="nav nav-sub d-flex">
            </ul>
            <br></br> */}

        </React.Fragment>
        )
}

export default SaleRomOnWebsite;